import { apiSlice } from 'store/slices/api/api-slice';
import serializeObjectToURI from 'util/serializer';
import {
    TeamByFilterListRequest,
    TeamByFilterListResponse,
    TeamDetailsRequest,
    TeamDetailsResponse,
} from 'types/team/team';

export const teamByFilterList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        teamByFilterList: builder.query<
            TeamByFilterListResponse,
            TeamByFilterListRequest | undefined
        >({
            query: (data?: TeamByFilterListRequest) => ({
                url: data
                    ? serializeObjectToURI(data, `team/team-by-filter-list?`)
                    : 'team/team-by-filter-list',
                method: 'GET',
            }),
        }),
        teamStatus: builder.query<string[], void>({
            query: () => ({
                url: '/team/team-status-enum',
                method: 'GET',
            }),
        }),

        teamType: builder.query<string[], void>({
            query: () => ({
                url: '/team/team-type-enum',
                method: 'GET',
            }),
        }),

        teamDetails: builder.query<TeamDetailsResponse, TeamDetailsRequest>({
            query: ({ teamId }) => ({
                url: `/team/team-details-info/${teamId}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLazyTeamByFilterListQuery,
    useTeamStatusQuery,
    useTeamTypeQuery,
    useTeamDetailsQuery,
} = teamByFilterList;
